import checkItemByCinemaId from "./checkItemByCinemaId"

const filterItemsByCinema = (order, items, cinemaId = false, cinemasAttr = 'cinemasFilter') => {
    const relevant = []

    if(false === cinemaId) {
        return order
    } else {
        order.map(itemId => {
            const item = items[itemId]

            if(checkItemByCinemaId(item, cinemaId, cinemasAttr)) {
                relevant.push(itemId)
            }
        })

        return relevant
    }
}

export default filterItemsByCinema